import React from 'react';
import { Button } from './ui/button';
import { MessageCircle, ShoppingBag, Smartphone } from 'lucide-react';
import { restaurantInfo } from '../data/mock';

const DeliverySection = () => {
  return (
    <section id="delivery" className="section-padding bg-neutral-900 relative overflow-hidden" aria-labelledby="delivery-heading">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_japamix-anapolys/artifacts/j9jj8cx2_PHOTO-2026-01-20-14-00-28%203.jpg"
          alt="Delivery japonês Anápolis Japamix"
          className="w-full h-full object-cover opacity-20"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-neutral-900 via-neutral-900/95 to-neutral-900/90" />
      </div>

      {/* Decorative elements */}
      <div className="absolute top-10 right-10 w-72 h-72 bg-amber-700/10 rounded-full blur-3xl" />
      <div className="absolute bottom-10 left-10 w-96 h-96 bg-amber-600/10 rounded-full blur-3xl" />

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <span className="text-amber-500 font-medium tracking-widest uppercase text-sm">
              Peça Agora
            </span>
            <h2 id="delivery-heading" className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mt-4 mb-6 leading-tight">
              Delivery Japonês em <span className="text-amber-500">Anápolis</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-700 to-amber-500 mb-8" />

            <p className="text-white/70 text-xl leading-relaxed mb-10">
              Peça agora e receba comida japonesa delivery em Anápolis onde estiver.
              Entrega rápida e pratos embalados com cuidado para manter a qualidade do seu sushi em Anápolis.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                size="lg"
                className="bg-amber-700 hover:bg-amber-800 text-white font-semibold px-8 py-6 text-lg btn-hover-lift flex justify-center items-center gap-3"
                onClick={() => window.open(restaurantInfo.deliveryUrl, '_blank')}
                aria-label="Pedir pelo site de delivery"
              >
                <ShoppingBag size={22} aria-hidden="true" />
                Pedir Online
              </Button>

              <Button
                size="lg"
                className="bg-green-600 hover:bg-green-700 text-white font-semibold px-8 py-6 text-lg btn-hover-lift flex justify-center items-center gap-3"
                onClick={() => window.open(`https://api.whatsapp.com/send/?phone=${restaurantInfo.whatsappDelivery}&text&type=phone_number&app_absent=0`, '_blank')}
                aria-label="WhatsApp Delivery"
              >
                <MessageCircle size={22} aria-hidden="true" />
                WhatsApp Delivery
              </Button>
            </div>

            {/* Secondary CTA */}
            <div className="mt-4 flex flex-col sm:flex-row">
              <Button
                variant="outline"
                size="lg"
                className="border-2 border-white/30 text-white hover:bg-white/10 font-semibold px-8 py-6 text-lg flex justify-center items-center gap-3 bg-transparent w-full sm:w-auto"
                onClick={() => window.open(`https://wa.me/${restaurantInfo.whatsapp}`, '_blank')}
                aria-label="WhatsApp Restaurante"
              >
                <Smartphone size={22} aria-hidden="true" />
                WhatsApp Restaurante
              </Button>
            </div>
          </div>

          {/* Image/Visual */}
          <div className="relative hidden lg:block">
            <figure className="relative">
              <img
                src="https://customer-assets.emergentagent.com/job_japamix-anapolys/artifacts/smaaa8s2_PHOTO-2026-01-20-14-00-28%202.jpg"
                alt="Sashimi fresco delivery Anápolis Japamix"
                className="w-full h-[500px] object-cover rounded-2xl shadow-2xl"
                loading="lazy"
              />
              <div className="absolute inset-0 rounded-2xl border-2 border-amber-600/20" />

              {/* Floating card */}
              <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-xl max-w-xs">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center">
                    <MessageCircle className="text-green-600" size={28} aria-hidden="true" />
                  </div>
                  <div>
                    <p className="font-semibold text-neutral-900">Atendimento rápido</p>
                    <p className="text-neutral-500 text-sm">Resposta em minutos</p>
                  </div>
                </div>
              </div>

              {/* Floating badge */}
              <div className="absolute -top-4 -right-4 bg-amber-700 text-white p-4 rounded-xl shadow-xl">
                <p className="font-bold text-2xl">30min</p>
                <p className="text-xs uppercase tracking-wider">Entrega média</p>
              </div>
            </figure>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DeliverySection;
